export { AuthSuccessView } from './auth-success-view';
export type { AuthSuccessViewProps } from './auth-success-view.types';
